import { render, staticRenderFns } from "./ModalRefaz.vue?vue&type=template&id=0f426a64&scoped=true"
import script from "./ModalRefaz.vue?vue&type=script&lang=js"
export * from "./ModalRefaz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f426a64",
  null
  
)

export default component.exports